export enum WorkspaceInfoError {
  FileRenameNotAllowed = 'WorkspaceInfoError.RenameNotAllowed',
  WorkspaceCreateNotAllowed = 'WorkspaceInfoError.WorkspaceCreateNotAllowed',
  WorkspaceDeleteNotAllowed = 'WorkspaceInfoError.WorkspaceDeleteNotAllowed',
  WorkspaceNotFound = 'WorkspaceInfoError.WorkspaceNotFound',
}
